import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'did_the_fac_participate_in_any_of_the_following_activities_rela_1'

export const dataPointDefinition = {
  retracedId: 'did_the_fac_participate_in_any_of_the_following_activities_rela_1',
  name: 'Did the facility participate in any of the following activities related to charitable contributions? (SELECT all that apply with an "X":)',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'THE_FACILITY_MADE_REGULAR_DONATIONS_TO_CHARITABLE__NON_PROFIT_N',
      text: 'The facility made regular donations to charitable (non-profit/non-governmental) organizations or projects',
      externalIds: [
        {
          id: 'ab-8-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-8-1f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FACILITY_CONDUCTED_A_NEEDS_ANALYSIS_OF_CHARITABLE_PROGRAMS_TO_A',
      text: 'Facility conducted a needs analysis of charitable programs to address the critical needs in the community',
      externalIds: [
        {
          id: 'ab-8-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-8-2f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ab-8-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ab-8-3f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'ab-8-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'THE_FACILITY_MADE_REGULAR_DONATIONS_TO_CHARITABLE__NON_PROFIT_N',
                'FACILITY_CONDUCTED_A_NEEDS_ANALYSIS_OF_CHARITABLE_PROGRAMS_TO_A',
                'OTHER',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ab-com-15',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 24880,
  sectionId: '2.2.2.4',
  impactArea: 'Community Impact',
  impactAreaId: 'COMMUNITY_IMPACT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
